import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {getUrlParameters} from '../../common/util/urlParameters';

export const fetchChassisListBySearchParam = (search) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/campaing/chasis/query${getUrlParameters(search)}`,
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_CAMPAIGN_CHASSIS_LIST,
        ActionTypes.FETCHED_CAMPAIGN_CHASSIS_LIST,
        [
          ActionTypes.FETCHED_CAMPAIGN_CHASSIS_LIST_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'GET',
    })
  );
};

export const fetchCampaignsListByChassis = (chassis) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/campaing/warranties/chasis/${chassis}`,
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_CAMPAIGN_LIST_BY_CHASSIS,
        ActionTypes.FETCHED_CAMPAIGN_LIST_BY_CHASSIS,
        [
          ActionTypes.FETCHED_CAMPAIGN_LIST_BY_CHASSIS_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'GET',
    })
  );
};

export const clearCampaignChassisList = () => {
  return {
    'type': ActionTypes.CLEAR_CAMPAIGN_CHASSIS_LIST,
  };
};

export const clearCampaignListByChassis = () => {
  return {
    'type': ActionTypes.CLEAR_CAMPAIGN_LIST_BY_CHASSIS,
  };
};
